import React from "react";
import SportsMaster from "../masters/SportsMaster";
import TournamentLevelMaster from "../masters/TournamentLevelMaster";
import TournamentUpdateMaster from "../masters/TournamentUpdateMaster";
import TournamentResultTypeMaster from "../masters/TournamentResultTypeMaster";

export default function TournamentMastersSection({ onDirectoryChange }) {
  return (
    <div id="td-masters" className="user-builder-panel" style={{ scrollMarginTop: "2rem" }}>
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Master table management</h3>
        <p className="user-builder-panel__hint">Lookups used by tournament forms.</p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          marginTop: "2rem",
        }}
      >
        <div id="td-levels" style={{ scrollMarginTop: "2rem" }}>
          <TournamentLevelMaster onDirectoryChange={onDirectoryChange} />
        </div>
        <hr style={{ border: "0", borderTop: "1px solid #e5e7eb" }} />
        <div id="td-updates" style={{ scrollMarginTop: "2rem" }}>
          <TournamentUpdateMaster onDirectoryChange={onDirectoryChange} />
        </div>
        <hr style={{ border: "0", borderTop: "1px solid #e5e7eb" }} />
        <div id="td-result-types" style={{ scrollMarginTop: "2rem" }}>
          <TournamentResultTypeMaster onDirectoryChange={onDirectoryChange} />
        </div>
        <hr style={{ border: "0", borderTop: "1px solid #e5e7eb" }} />
        <div id="td-sports" style={{ scrollMarginTop: "2rem" }}>
          <SportsMaster onDirectoryChange={onDirectoryChange} />
        </div>
      </div>
    </div>
  );
}
